import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import TechStack from './components/TechStack';
import Projects from './components/Projects';
import WidgetsSection from './components/WidgetsSection';
import Baseball from './components/Baseball';
import LinksBar from './components/LinksBar';
import Reveal from './components/Reveal';

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-black to-slate-950 text-slate-50">
      <Header title="Nate Verlin" />
      <main className="mx-auto max-w-6xl px-4 pb-16 pt-8 space-y-24">
        <section id="hero">
          <Reveal>
            <Hero />
          </Reveal>
        </section>
        <section id="about">
          <Reveal delayClassName="reveal-delay-sm">
            <About />
          </Reveal>
        </section>
        <section id="experience">
          <Reveal delayClassName="reveal-delay-md">
            <Experience />
          </Reveal>
        </section>
        <section id="tech">
          <Reveal>
            <TechStack />
          </Reveal>
        </section>
        <section id="projects">
          <Reveal delayClassName="reveal-delay-sm">
            <Projects />
          </Reveal>
        </section>
        <section id="widgets">
          <Reveal delayClassName="reveal-delay-md">
            <WidgetsSection />
          </Reveal>
        </section>
        <section id="baseball">
          <Reveal>
            <Baseball />
          </Reveal>
        </section>
      </main>
      <footer className="border-t border-slate-800/80 bg-slate-950/90">
        <div className="mx-auto max-w-6xl px-4 py-6">
          <div className="mb-6 flex justify-center">
            <Link
              to="/cooler-stuff"
              className="group relative inline-flex items-center gap-2 overflow-hidden rounded-xl border-2 border-cyan-400/60 bg-slate-900/90 px-6 py-3 font-mono text-sm font-bold uppercase tracking-[0.25em] text-cyan-300 shadow-[0_0_20px_rgba(34,211,238,0.3)] transition-all duration-300 hover:border-cyan-300 hover:shadow-[0_0_30px_rgba(34,211,238,0.5)] hover:text-cyan-200"
            >
              <span className="absolute inset-0 bg-gradient-to-r from-cyan-500/0 via-cyan-400/20 to-cyan-500/0 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
              <span className="relative">Cooler Stuff</span>
              <span className="relative text-cyan-400 transition-transform duration-300 group-hover:translate-x-1">→</span>
            </Link>
          </div>
          <LinksBar />
        </div>
      </footer>
    </div>
  );
}

export default App;
